import request from "../utils/request";

export const addAddress = (data) => {
  return request({
    method: "post",
    url: "/user-address",
    data,
  });
};
export const editAddress = (data) => {
  return request({
    method: "put",
    url: "/user-address",
    data,
  });
};
export const getAddressList = () => {
  return request({
    method: "get",
    url: "/user-address/list",
  });
};
export const deleteAddress = (data) => {
  return request({
    method: "delete",
    url: `/user-address/${data.id}`,
  });
};
export const getAddressDetail = (data) => {
  return request({
    method: "get",
    url: `/user-address/${data.id}`,
  });
};
export const addDefault = (data) => {
  return request({
    method: "patch",
    url: `/user-address/default/${data.id}`,
  });
};
